import React from 'react';


const tecno = [
    { T: 'React', L: 'https://es.reactjs.org/' },
    { T: 'HTML', L: 'https://www.w3schools.com/html/' },
    { T: 'CSS', L: 'https://www.w3schools.com/css/' },

];


class Oldporfolio extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">





                    <div className="sectionProyect">


                        <div className="titleSectionProyect">
                            <h1>Old porfolio</h1>

                        </div>
                        <svg> <rect></rect> </svg>

                        <div className="imageProyect imageOldporfolio"></div>

                        <div className="listT" >

                            {tecno.map(tec => (
                                <div key={tec}>
                                    <a href={tec.L} target="_blank" rel="noreferrer">

                                        <button className="animateButtonTech">  <p> <span>&#183;</span> {tec.T}</p></button>
                                    </a>
                                </div>

                            ))}
                        </div>

                        <p>Old version of my portfolio, I wanted it to have a simple design, but I decided to change the design for a simple but more animated one with some improvements.</p>
                        <a href="https://brandongrimaldom.github.io/" target="_blank" rel="noreferrer">
                        <button className="animateButtonGit"> <p>GitHub Pages </p> <div className="gitIcon"></div> </button>
                        </a>
                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default Oldporfolio;